import React, {Component} from "react"
import {Button, Container, Header, Loader, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization, interpolateString} from "../utils/localization";
import {connect} from "react-redux";
import {setPrevRoute} from "../actions/appHeaderActions";
import {checkIsVerified, EDUCATIONAL_AUTO_ADVANCE_SECONDS, formatMoneyAmount, getStepProps, isAnsel} from "../utils/common";
import Steps from "./steps/steps";
import Footer from "./footer";
import CoveredModal from "./coveredModal";
import LimitationsExclusionsModal from "./limitationsExclusionsModal";
import {ClickableText, CustomDivider, CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {BenefitLimitsShortExplanationsRequest} from "../services/types";
import {benefitLimitsShortExplanations} from "../services/services";

const mapStateToProps = (state, ownProps) => {
    const {user, initialData, benAdmin} = state;
    const { policy } = initialData;
    return {
        ...ownProps,
        lang: user.lang,
        initialData, user, benAdmin,
        isBrellaChoice: !!initialData && !!initialData.contractInfo && initialData.contractInfo.planOffering === "Brella Choice",
        catastrophicMaximumOccurrences: policy.catastrophicRecurrencyLimit,
    }
};

class ConditionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepProps: null,
            activeIndex: [],
            displayCoveredModal: false,
            renderLimitationsAndExclusionsModal: false,
            explanations: null,
        };
    }

    async componentDidMount() {
        const {initialData, user, benAdmin} = this.props;
        checkIsVerified(user, benAdmin, initialData.uiFlow, this.props, initialData.distributionChannel);
        this.props.dispatch(setPrevRoute(this.props.prevRoute));
        await this.getBenefitLimitsShortExplanations();
        this.buildSteps();
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.lang !== this.props.lang) {
            this.buildSteps();
            await this.getBenefitLimitsShortExplanations();
        }
    }

    async getBenefitLimitsShortExplanations()  {
        const { lang, initialData } = this.props;

        try {
            const request = new BenefitLimitsShortExplanationsRequest({
                languageCode: lang,
                contractTerms: initialData.ratedClass.contractTerms
            });
            const {explanations} = await benefitLimitsShortExplanations(request);
            this.setState({explanations});
        } catch (error) {
            console.error("Error fetching benefit limits:", error);
        }
    }

    buildSteps = () => {
        const {initialData: {uiFlow, distributionChannel}, lang} = this.props;
        const localization = getLocalization(lang);
        this.setState({stepProps: getStepProps(localization, 0, uiFlow, distributionChannel)});
    }

    handleTitleClick = (e, index) => {
        let {activeIndex} = this.state
        let existingIdx = null;
        const existing = activeIndex.filter((a, idx) => {
            if (a === index) {
                existingIdx = idx;
                return true;
            }
            return false;
        });
        if (existing.length === 0) {
            activeIndex.push(index)
        } else if (existingIdx !== null) {
            activeIndex.splice(existingIdx, 1)
        }
        this.setState({activeIndex: [...activeIndex]})
    }

    doDisplayCoveredModal = (status) => {
        this.setState({
            displayCoveredModal: status
        });
    }

    renderFullListOfConditionsModal = (localization) => {
        const {displayCoveredModal} = this.state;
        return <CoveredModal localization={localization}
                             displayCoveredModal={displayCoveredModal}
                             onModalClose={() => this.doDisplayCoveredModal(false)}
        />;
    }

    closeModal = () => {
        this.setState({renderLimitationsAndExclusionsModal: false})
    }

    paymentColumnTitle = (inc) => {
        const {lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.conditionDetails;
        if (lang === 'en') {
            return {
                moderate:  `${strings.choiceIncrements} $${formatMoneyAmount(inc.moderate[0])} - $${formatMoneyAmount(inc.moderate[inc.moderate.length - 1])}`,
                severe: `${strings.choiceIncrements} $${formatMoneyAmount(inc.severe[0])} - $${formatMoneyAmount(inc.severe[inc.severe.length - 1])}`,
                catastrophic: `${strings.choiceIncrements} $${formatMoneyAmount(inc.catastrophic[0])} - $${formatMoneyAmount(inc.catastrophic[inc.catastrophic.length - 1])}`
            }
        }
        return {
            moderate:  `${strings.choiceIncrements} $${formatMoneyAmount(inc.moderate[0])} a $${formatMoneyAmount(inc.moderate[inc.moderate.length - 1])}`,
            severe: `${strings.choiceIncrements} $${formatMoneyAmount(inc.severe[0])} a $${formatMoneyAmount(inc.severe[inc.severe.length - 1])}`,
            catastrophic: `${strings.choiceIncrements} $${formatMoneyAmount(inc.catastrophic[0])} a $${formatMoneyAmount(inc.catastrophic[inc.catastrophic.length - 1])}`
        }
    }

    findExplanationByCategory = (candidateCategory) => {
        const {explanations} = this.state;
        return explanations?.find(({category}) => candidateCategory === category)?.description || '';
    }

    render() {
        const {stepProps, activeIndex} = this.state;
        const {initialData, isBrellaChoice, catastrophicMaximumOccurrences} = this.props;
        if (!stepProps) {
            return <Container><Loader active={true}/></Container>
        }

        const localization = getLocalization(this.props.lang);
        const strings = localization.conditionDetails;

        let moderatePaymentColumnTitle = '';
        let severePaymentColumnTitle = '';
        let catastrophicPaymentColumnTitle = '';
        if (isBrellaChoice) {
            if (!!initialData && !!initialData.increments) {
                try {
                    const paymentColumnTilte = this.paymentColumnTitle(initialData.increments);
                    moderatePaymentColumnTitle = paymentColumnTilte.moderate;
                    severePaymentColumnTitle = paymentColumnTilte.severe;
                    catastrophicPaymentColumnTitle = paymentColumnTilte.catastrophic;
                } catch (e) {
                    console.error(e);
                    moderatePaymentColumnTitle = `${strings.choiceIncrements}`;
                    severePaymentColumnTitle = `${strings.choiceIncrements}`;
                    catastrophicPaymentColumnTitle = `${strings.choiceIncrements}`;
                }
            }
        } else {
            if (!!initialData && !!initialData.presets) {
                const pre = initialData.presets;
                moderatePaymentColumnTitle = `${strings.selectPayout} $${formatMoneyAmount(pre.value.moderate)}, $${formatMoneyAmount(pre.enhanced.moderate)} ${strings.or} $${formatMoneyAmount(pre.premier.moderate)}`;
                severePaymentColumnTitle = `${strings.selectPayout} $${formatMoneyAmount(pre.value.severe)}, $${formatMoneyAmount(pre.enhanced.severe)} ${strings.or}  $${formatMoneyAmount(pre.premier.severe)}`;
                catastrophicPaymentColumnTitle = `${strings.selectPayout} $${formatMoneyAmount(pre.value.catastrophic)}, $${formatMoneyAmount(pre.enhanced.catastrophic)} ${strings.or}  $${formatMoneyAmount(pre.premier.catastrophic)}`;
            }
        }

        const panels = [
            {
                title: `${strings.moderateTitle}`,
                whatIsTitle: `${strings.moderateWhatIsTitle}`,
                whatIsText: `${strings.moderateWhatIsText}`,
                coversTitle: `${strings.moderateCoversTitle}`,
                coversText: `${strings.moderateCoversText}`,
                payoutContent: this.findExplanationByCategory("Moderate"),
                image:'CONDITION_MODERATE_112PX',
                paymentTitle: moderatePaymentColumnTitle,
                days: initialData.policy.moderateSeparationPeriod
            },
            {
                title: `${strings.severeTitle}`,
                whatIsTitle: `${strings.severeWhatIsTitle}`,
                whatIsText: `${strings.severeWhatIsText}`,
                coversTitle: `${strings.severeCoversTitle}`,
                coversText: `${strings.severeCoversText}`,
                payoutContent: this.findExplanationByCategory("Severe"),
                image:'CONDITION_SEVERE_112PX',
                paymentTitle: severePaymentColumnTitle,
                days: initialData.policy.severeSeparationPeriod
            },
            {
                title: `${strings.catastrophicTitle}`,
                whatIsTitle: `${strings.catastrophicWhatIsTitle}`,
                whatIsText: `${strings.catastrophicWhatIsText}`,
                coversTitle: `${strings.catastrophicCoversTitle}`,
                coversText: `${strings.catastrophicCoversText}`,
                payoutContent: this.findExplanationByCategory("Catastrophic"),
                image:'CONDITION_CATASTROPHIC_112PX',
                paymentTitle: catastrophicPaymentColumnTitle,
                days: initialData.policy.catastrophicSeparationPeriod
            }
        ]

        return (
            <React.Fragment>
                <Container className={'contentContainer'}>
                    <Steps stepProps={stepProps} uiFlow={this.props.initialData.uiFlow}/>
                    {this.renderFullListOfConditionsModal(localization)}
                    {this.state.renderLimitationsAndExclusionsModal &&
                    <LimitationsExclusionsModal strings={localization.limitationsAndExclusions}
                                                renderModal={this.state.renderLimitationsAndExclusionsModal}
                                                closeModal={this.closeModal}/>}
                    <CustomGrid container stackable columns={1} centered className={`contentStepsSpacer ${isAnsel() && "largerContentStepsSpacer"}`} fitted={'horizontally'}>
                        <CustomGrid.Column width={8}>
                            <CustomGrid stackable columns={1}>
                                <CustomGrid.Column className={"pageContent"}>
                                    <Header as='h2'>{strings.title}</Header>
                                    <p>{strings.subTitle}</p>
                                    <CustomDivider hidden/>
                                    <span className={"primaryHeaderColor"}><b>{strings.covers}</b></span>
                                </CustomGrid.Column>
                                <CustomGrid.Row>

                                    <CustomGrid.Column className={"pageContent"}>
                                        {panels.map((panel, i) => {
                                            const isActive = activeIndex.filter((ai) => ai === i).length > 0;
                                            return (
                                                <CustomGrid key={i}>
                                                    <CustomGrid.Column width={1} className={"pageContent"}>
                                                        <S3Image {...IMAGE.CIRCLE_CHECK} style={{marginTop:'14px'}}/>
                                                    </CustomGrid.Column>
                                                    <CustomGrid.Column width={11}>
                                                        <Segment>
                                                            <div>
                                                                <Header as="h4" floated={"left"} style={{marginBottom: isActive ? '1em' : 0}}>{panel.title}</Header>
                                                                <div style={{
                                                                            float: 'right',
                                                                            marginTop: '5px'
                                                                        }}>
                                                                    <ClickableText onClick={(e) => {
                                                                        this.handleTitleClick(e, i)
                                                                    }} small>{isActive ? strings.hide : strings.see} {strings.categoryDetails}</ClickableText>
                                                                </div>
                                                                <div style={{clear: 'both'}}/>
                                                            </div>
                                                            {!!isActive && <div>
                                                                <CustomGrid columns={1} style={{margin: 0}}
                                                                      className={"small"}>
                                                                    <CustomGrid.Column style={{paddingTop: 0}}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginBottom: '1em'
                                                                        }}>
                                                                            <S3Image {...IMAGE[panel.image]}
                                                                                     style={{marginRight: '1.5em',
                                                                                         marginBottom: '.5em'
                                                                                    }}/>
                                                                            <div>
                                                                                <div className="primaryHeaderColor"
                                                                                     style={{marginBottom: '7px'}}>
                                                                                    <b>{panel.whatIsTitle}</b></div>
                                                                                <span>{panel.whatIsText}</span>
                                                                            </div>
                                                                        </div>

                                                                        <p>
                                                                    <span className="primaryHeaderColor">
                                                                            <b>{panel.coversTitle}</b></span>
                                                                            <span> {panel.coversText}</span>
                                                                        </p>

                                                                        <p className="primaryHeaderColor" style={{margin: '1.5em 0'}}>
                                                                            <b>{panel.paymentTitle}.</b>
                                                                        </p>

                                                                        <p>
                                                                            {interpolateString(panel.payoutContent, [panel.days, catastrophicMaximumOccurrences])}
                                                                            <ClickableText onClick={() => {
                                                                                this.setState({renderLimitationsAndExclusionsModal: true})
                                                                            }}> {strings.learnMore}</ClickableText>
                                                                        </p>
                                                                    </CustomGrid.Column>
                                                                </CustomGrid>
                                                            </div>}
                                                        </Segment>
                                                    </CustomGrid.Column>
                                                </CustomGrid>
                                            )
                                        })}
                                        <CustomDivider hidden/>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>

                                <CustomGrid.Row style={{paddingTop: 0}}>
                                    <CustomGrid.Column width={3} style={{paddingRight: 0}}>
                                        <S3Image {...IMAGE.PEACE_OF_MIND_MOM_WITH_CHILD}/>
                                    </CustomGrid.Column>
                                    <CustomGrid.Column width={9} className="small">
                                        <CustomGrid.Row>
                                            <b>{strings.whatsNotCovered}</b><br/>
                                            {strings.uncovered}
                                        </CustomGrid.Row>

                                        <CustomGrid.Row style={{marginTop: '1.4em'}}>
                                            <Button primary basic onClick={() => this.doDisplayCoveredModal(true)}>
                                                <b>{strings.fullListLink}</b>
                                            </Button>
                                        </CustomGrid.Row>
                                        <CustomGrid.Row style={{marginTop: '0.7em', fontSize: '12px'}}>
                                            <span className={'conditionAsterisk'}>*</span>{strings.fullListDisclaimer}
                                        </CustomGrid.Row>
                                    </CustomGrid.Column>
                                </CustomGrid.Row>

                            </CustomGrid>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer
                    showTopFooter={true} showCenterData={true}
                    buttonText={localization.next}
                    onClickCallback={() => this.props.history.push(this.props.nextRoute)}
                    autoAdvanceSeconds={EDUCATIONAL_AUTO_ADVANCE_SECONDS}
                    pauseAutoAdvance={this.state.displayCoveredModal || this.state.renderLimitationsAndExclusionsModal}
                />
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(ConditionDetails));
